import firebase from 'firebase/app'
require('firebase/firestore')

const config = {
  apiKey: 'AIzaSyCl-D-_3VIeGLo4xjRLt52n9xioZXFkEAg',
  authDomain: 'logimedweb.firebaseapp.com',
  databaseURL: 'https://logimedweb.firebaseio.com',
  projectId: 'logimedweb',
  storageBucket: 'logimedweb.appspot.com',
  messagingSenderId: '578372936767'
}

firebase.initializeApp(config)
export const db = firebase.firestore()
